import React, { useState, useRef, useEffect, useMemo } from 'react';
import './css/CornerWeatherPreview.css';
import './css/CornerWeatherPreviewResponsive.css';
import { WEATHER_TRANSLATIONS } from '../../../../../Constants/apps';
import { useSelector } from 'react-redux';
import { getDisplayName } from '../../Helpers';



const CornerWeatherPreview = ({ area, setArea, xs = false, data, previewMode, settings }) => {
  const containerRef = useRef(null);
  const containerDeviceRef = useRef(null);


  const { weatherTextColor } = useSelector(state => state.apps);

  const [isLandscape, setIsLandscape] = useState(true);
  const [loading, setLoading] = useState(true);

  const [containerWidth, setContainerWidth] = useState();
  const [containerHeigh, setContainerHeigh] = useState();
  const [layout, setLayout] = useState(area?.layout || 'landscape-wide');

  useEffect(() => {
    if (!previewMode) {
      setLayout(area?.layout)
    }
  }, [area]);



  const handleMouseDown = (e, action) => {
    e.preventDefault();
    e.stopPropagation();

    const startX = e.clientX;
    const startY = e.clientY;

    const container = containerRef.current;
    const initial = { ...area };

    const onMouseMove = (e) => {
      const dx = ((e.clientX - startX) / containerWidth) * 100;
      const dy = ((e.clientY - startY) / containerHeigh) * 100;

      let updated = { ...initial };

      if (action === 'move') {
        updated.start_margin = Math.min(100 - initial.width, Math.max(0, initial.start_margin + dx));
        updated.top_margin = Math.min(100 - initial.height, Math.max(0, initial.top_margin + dy));
      }

      if (action === 'right') {
        updated.width = Math.min(100 - initial.start_margin, Math.max(5, initial.width + dx));
      }

      if (action === 'bottom') {
        updated.height = Math.min(100 - initial.top_margin, Math.max(5, initial.height + dy));
      }
      const isNowLandscape = updated.width / updated.height;
      setIsLandscape(isNowLandscape > 0.8);
      if (isNowLandscape > 0.683) {
        setLayout('landscape-wide');
        updated.layout = 'landscape-wide';
      } else if (isNowLandscape < 0.683) {
        setLayout('portrait');
        updated.layout = 'portrait';
      };

      setArea(updated);

    }
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };


  const [currentTime, setCurrentTime] = useState(new Date());
  const isDay = data?.current.is_day == 1 ? 1 : 0;

  const isCelsius = previewMode ? settings.unit === "c" : data?.media?.weather?.settings?.unit?.toLowerCase() === "c";
  const languageRtl = previewMode ? settings.lang_direction === "rtl" : data?.media?.weather?.settings?.lang_direction === "rtl";
  const display_name = useMemo(() => getDisplayName({ previewMode, settings, data }), [previewMode, settings, data]);
  // const display_name = (previewMode ?
  //   (settings.lang != "en" ?
  //     (settings.location_display ? settings.location_display : "Enter City Name")
  //     : data?.location?.name) : (data?.media?.weather?.settings?.location_display || data?.media?.weather?.settings?.location));


  const lang = previewMode ? settings.lang ? settings.lang : "en" : data?.media?.weather?.settings?.lang;
  const langTranslate = WEATHER_TRANSLATIONS[lang];

  useEffect(() => {


    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      setContainerWidth(containerRect.width);
      setContainerHeigh(containerRect.height);
      setLoading(false)
    }

    if (!previewMode) {
      if (containerDeviceRef.current) {
        const containerRect = containerDeviceRef.current.getBoundingClientRect();
        setContainerWidth(containerRect.width);
        setContainerHeigh(containerRect.height);
        setLoading(false)
      }
    }

    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const today = new Date();
  const nextDay = new Date(today);
  nextDay.setDate(today.getDate() + 1);
  const next2Day = new Date(today);
  next2Day.setDate(today.getDate() + 2);

  const currentDay = today.toLocaleDateString(lang, { weekday: "short", month: "long", day: "numeric" });

  const time = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const getWeatherIcon = (isDay, code) => {
    try {
      return require(`../../../../../assets/img/weather-icons/${isDay}/${code || 1000}.png`);
    } catch {
      return require(`../../../../../assets/img/weather-icons/1/1000.png`);
    }
  };


  return (
    <div
      ref={containerRef}
      className="corner-container"
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        overflow: 'hidden',
      }}
    >
      <div
        ref={containerDeviceRef}
        className={`resizable-box ${isLandscape ? "" : "flex-column"}`}
        onMouseDown={previewMode ? (e) => handleMouseDown(e, 'move') : ""}
        style={{
          position: 'absolute',
          left: `${area.start_margin}%`,
          top: `${area.top_margin}%`,
          width: `${area.width}%`,
          height: `${area.height}%`,
          backgroundColor: 'transparent',
          border: `${previewMode ? '3px dotted #333' : ""}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: `${weatherTextColor}`,
          cursor: `${!previewMode && 'move'}`,
          // overflow: 'hidden',
        }}
      >
        {!loading && (<>

          {layout === 'landscape-wide' && (
            <div className="layout-wide d-flex justify-content-between align-items-center w-100 h-100 p-3 ">

              <div className={`w-[65%]  flex flex-wrap  justify-content-center align-items-center `}
                style={{
                  flexFlow: `${containerWidth / containerHeigh > 1.4 ? "row-reverse" : ""}`,
                  gap: `${containerWidth / containerHeigh > 1.4 ? "10px" : ""}`,
                  justifyContent: `${containerWidth / containerHeigh > 1.4 ? "space-between" : "space-between"}`


                }}>
                <div className=" ">
                  <div
                    style={previewMode ?
                      { fontSize: `${Math.min((area.width / 15 / 100) * containerWidth, (area.height / 15 / 100) * containerHeigh * 2)}px` } :
                      {
                        // fontSize: `${area.width / 15}vw`
                        fontSize: `${Math.min(containerWidth / 15, (containerHeigh / 5))}px`,

                      }

                    } alt="icon"
                    className={`text-start`}>{display_name}</div>
                  <div
                    style={previewMode ? { fontSize: `${Math.min((area.width / 25 / 100) * containerWidth, (area.height / 25 / 100) * containerHeigh * 2)}px` } : { fontSize: `${area.width / 25}vw` }} alt="icon"
                  >{currentDay} {time}</div>
                </div>
                <div className=" gap-2 flex  justify-content-center flex-column" >
                  <div className="w-100temperature d-flex aligns-item-start justify-content-center">
                    <div className={``}
                      style={
                        previewMode ? {
                          lineHeight: `${Math.min((area.width / 5 / 100) * containerWidth, (area.height / 5 / 100) * containerHeigh * 2)}px`,
                          fontSize: `${Math.min((area.width / 5 / 100) * containerWidth, (area.height / 5 / 100) * containerHeigh * 2)}px`
                        } : {
                          fontSize: `${Math.min(containerWidth / 5, (containerHeigh / 2))}px`,
                          lineHeight: `${Math.min(containerWidth / 5, (containerHeigh / 2))}px`,
                          // fontSize: `${area.width / 5}vw`,
                          // lineHeight: `${area.width / 5}vw`
                        }} alt="icon"
                    >{isCelsius ? Math.round(data?.current?.temp_c) : Math.round(data?.current?.temp_f)}</div>
                    <div
                      style={previewMode ?
                        { fontSize: `${Math.min((area.width / 25 / 100) * containerWidth, (area.height / 25 / 100) * containerHeigh * 2)}px` } :
                        //  { fontSize: `${area.width / 25}vw` }
                        { fontSize: `${Math.min(containerWidth / 25, (containerHeigh / 12.5))}px` }

                      } alt="icon"
                      className={``}>°{isCelsius ? 'C' : 'F'}</div>
                  </div>
                  <div className="feels-like text-center"
                    style={previewMode ?
                      { fontSize: `${Math.min((area.width / 25 / 100) * containerWidth, (area.height / 25 / 100) * containerHeigh * 2)}px` } :
                      // { fontSize: `${area.width / 25}vw` }
                      { fontSize: `${Math.min(containerWidth / 25, (containerHeigh / 12.5))}px` }

                    } alt="icon"
                  >{languageRtl ? (
                    <>
                      {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}
                      °{langTranslate["feels_like"]}
                    </>
                  ) : (
                    <>
                      {langTranslate["feels_like"]}
                      {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}   °
                    </>
                  )}</div>
                </div>
              </div>


              <div className="icon-block d-flex flex-column  ">
                <img
                  src={getWeatherIcon(isDay, data?.current?.condition?.code)}
                  className="img-fluid"
                  style={previewMode ? {
                    width: `${(area.width / 2.5 / 100) * containerWidth}px`,
                    height: 'auto',
                    maxHeight: `${(area.height / 100) * containerHeigh * 0.8}px`,
                    objectFit: 'contain',
                  }
                    :
                    {
                      width: `${0.2 * containerWidth}px`,
                      height: 'auto',
                      maxHeight: `${(containerWidth / 0.4)}px`,
                      objectFit: 'contain',
                    }}
                  alt="icon"
                />


                <p className="condition text-center"
                  style={previewMode ?
                    { fontSize: `${Math.min((area.width / 25 / 100) * containerWidth, (area.height / 25 / 100) * containerHeigh * 2)}px` } :
                    // { fontSize: `${area.width / 25}vw` }} alt="icon"
                    { fontSize: `${Math.min(containerWidth / 25, (containerHeigh / 12.5))}px` }
                  } alt="icon"


                >{data?.current?.condition?.text}</p>
              </div>
            </div>
          )}

          {layout === 'portrait' && (
            <div className="portrait d-flex flex-column justify-content-between  align-items-center  w-100 h-100 p-3 ">

              <div className={`w-[100%]`}>
                <div className={` w-100 d-flex justify-content-between`}>
                  <div className={` flex-column  justify-content-center d-flex`}>
                    {/* name */}
                    <div
                      style={previewMode ? { fontSize: `${(area.width / 10 / 100) * containerWidth}px` } : { fontSize: `${area.height / 10}vh` }} alt="icon"
                      className={``}>{display_name}
                    </div>

                    {/* date */}
                    <div
                      style={previewMode ? { fontSize: `${Math.min((area.width / 25 / 100) * containerWidth, (area.height / 25 / 100) * containerHeigh * 2)}px` } : { fontSize: `${area.height / 25}vh` }} alt="icon"
                    >{currentDay} {time}
                    </div>

                    {/* feels-like */}
                    <div className="feels-like text-center"
                      style={previewMode ? { fontSize: `${(area.width / 25 / 100) * containerWidth}px` } : { fontSize: `${area.height / 25}vh` }} alt="icon"

                    >{languageRtl ? (
                      <>
                        {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}
                        °{langTranslate["feels_like"]}
                      </>
                    ) : (
                      <>
                        {langTranslate["feels_like"]}
                        {isCelsius ? Math.round(data?.current?.feelslike_c) : Math.round(data?.current?.feelslike_f)}   °
                      </>
                    )}</div>
                  </div>

                  <div className={` flex-column  justify-content-center d-flex`}>
                    {/* temperature */}
                    <div className="temperature d-flex aligns-item-start justify-content-center">
                      <div className={``}
                        style={previewMode ? { fontSize: `${(area.width / 4.5 / 100) * containerWidth}px` } : { fontSize: `${area.height / 4.5}vh` }} alt="icon"

                      >{isCelsius ? Math.round(data?.current?.temp_c) : Math.round(data?.current?.temp_f)}</div>
                      <div
                        style={previewMode ? { fontSize: `${(area.width / 25 / 100) * containerWidth}px` } : { fontSize: `${area.height / 25}vh` }} alt="icon"
                        className={``}>°{isCelsius ? 'C' : 'F'}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="icon-block d-flex flex-column justify-content-center aligns-items-center w-100">
                <div className=" d-flex justify-content-center aligns-self-center text-center ">
                  <img
                    src={getWeatherIcon(isDay, data?.current?.condition?.code)}
                    className="img-fluid text-center"
                    style={previewMode ? { width: `${(area.width / 2 / 100) * containerWidth}px` } : { width: `${area.height / 2}vh` } || { width: "200px" }} alt="icon"
                  />
                </div>
                <p className="condition text-center"
                  style={previewMode ? { fontSize: `${(area.width / 25 / 100) * containerWidth}px` } : { fontSize: `${area.height / 25}vh` }} alt="icon"
                >{data?.current?.condition?.text}</p>
              </div>
            </div>
          )}
        </>
        )}



        {/* Resize handles */}
        {/* <div className="resize-handle" style={previewMode ? { top: "50%", left: -5, cursor: "ew-resize" } : { visibility: "hidden" }} onMouseDown={previewMode ? (e) => handleMouseDown(e, 'left') : ""}></div> */}
        {/* <div className="resize-handle" style={previewMode ? { top: -5, right: "50%", cursor: "ns-resize" } : { visibility: "hidden" }} onMouseDown={previewMode ? (e) => handleMouseDown(e, "up") : ""}></div> */}
        <div className="resize-handle" style={previewMode ? { bottom: -5, right: "50%", cursor: "ns-resize" } : { visibility: "hidden" }} onMouseDown={previewMode ? (e) => handleMouseDown(e, "bottom") : ""}></div>
        <div className="resize-handle" style={previewMode ? { top: "50%", right: -5, cursor: "ew-resize" } : { visibility: "hidden" }} onMouseDown={previewMode ? (e) => handleMouseDown(e, "right") : ""}></div>
      </div>
    </div >
  );
};

export default CornerWeatherPreview;


